import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROLES, USER_TYPES } from 'src/app/constant/constant';
import { UserRoleAuthorizeGuard } from 'src/app/guards/user-role-authorize.guard';
import { AuthEgdGuard } from '../../../guards/auth-egd.guard';
import { DoctorAgreementComponent } from '../shared/doctor-agreement/doctor-agreement.component';
import { ComposeEmailComponent } from '../shared/compose-email/compose-email.component';
import { DmessageCenterComponent } from '../shared/dmessage-center/dmessage-center.component';
import { DoctordataComponent } from '../shared/doctordata/doctordata.component';
import { DoctorvideosectionComponent } from '../shared/doctorvideosection/doctorvideosection.component';
import { MailViewComponent } from '../shared/mail-view/mail-view.component';
import { MedicalProfessionDashboardComponent } from '../shared/medical-profession-dashboard/medical-profession-dashboard.component';
import { ScheduleComponent } from '../shared/schedule/schedule.component';
import { OtherMedicalProfessionEditComponent } from './other-medical-profession-edit/other-medical-profession-edit.component';
// import { OtherMedicalProfessionDashboardComponent } from './other-medical-profession-dashboard/other-medical-profession-dashboard.component';
import { OtherMedicalProfessionHomeComponent } from './other-medical-profession-home/other-medical-profession-home.component';
import { NovspecialDoctordashboardComponent } from '../shared/novspecial-doctordashboard/novspecial-doctordashboard.component';
import { AppointmentsComponent } from '../shared/appointments/appointments.component';
import { PatientviewComponent } from '../../shared/patient-view/patientview/patientview.component';
import { PatientsComponent } from '../shared/patients/patients.component';

const userTypes = USER_TYPES;


const routes: Routes = [
    {
        path:  `:slug/${userTypes['OTHER-MEDICAL-PROFESSIONALS']}`,
        component: MedicalProfessionDashboardComponent,
        canActivate: [UserRoleAuthorizeGuard],
        canActivateChild: [UserRoleAuthorizeGuard, AuthEgdGuard],
        data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"], ROLES["Other_Medical_Professional_Admin"]] },
        children: [
            {
                path: 'dashboard',
                canActivate: [UserRoleAuthorizeGuard],
                component: OtherMedicalProfessionHomeComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"], ROLES["Other_Medical_Professional_Admin"]] },
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'profiles',
                canActivate: [UserRoleAuthorizeGuard],
                component: DoctordataComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"]] },
            },
            {
                path: 'doctor-videosection',
                canActivate: [UserRoleAuthorizeGuard],
                component: DoctorvideosectionComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"]] },
            },
            {
                path: 'schedules',
                canActivate: [UserRoleAuthorizeGuard],
                component: ScheduleComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"], ROLES["Other_Medical_Professional_Admin"]] },
            },
            {
                path: 'message-center',
                canActivate: [UserRoleAuthorizeGuard],
                component: DmessageCenterComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"]] },
            },
            {
                path: 'compose-email',
                canActivate: [UserRoleAuthorizeGuard],
                component: ComposeEmailComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"]] },
            },
            {
                path: 'mailview/:user_guid/:message_id/:sent',
                canActivate: [UserRoleAuthorizeGuard],
                component: MailViewComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"]] },
            },
            {
                path: 'edit',
                canActivate: [UserRoleAuthorizeGuard],
                component: OtherMedicalProfessionEditComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"], ROLES["Other_Medical_Professional_Admin"]] },
            },
            {
                path: 'Free-Medical-Counseling',
                canActivate: [UserRoleAuthorizeGuard],
                component: NovspecialDoctordashboardComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"]] },
            },
            {
                path: 'appointments',
                canActivate: [UserRoleAuthorizeGuard],
                component: AppointmentsComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"], ROLES["Other_Medical_Professional_Admin"]] },
            },
            {
                path: 'appointments/patient-view/:patient_guid/:consultation_id',
                canActivate: [UserRoleAuthorizeGuard],
                component: PatientviewComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"], ROLES["Other_Medical_Professional_Admin"]] },
            },
            {
                path: 'patients',
                canActivate: [UserRoleAuthorizeGuard],
                component: PatientsComponent,
                data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"], ROLES["Other_Medical_Professional_Admin"]] },
            }
        ]
    },
    {
        path: userTypes['OTHER-MEDICAL-PROFESSIONALS'] + '/agreement',
        canActivate: [UserRoleAuthorizeGuard],
        component: DoctorAgreementComponent,
        data: { role_type: "other_medical_professionals", sub_role: [ROLES["Other_Medical_Professional"]] },
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class OtherMedicalProfessionRoutingModule { }
